import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ExtensionsOfTimeHandoverContent from '../content/eotsHandoverContent';
import addHandoverWrapper from '../handoverWrapper';

class ExtensionsOfTimeHandover extends React.Component {
	static getTitle() {
		return 'Extensions of Time';
	}

	render() {
		const report = this.props.report.data[0];
		
		return (
			<ExtensionsOfTimeHandoverContent report={report} />
		);
	}
}

ExtensionsOfTimeHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	ExtensionsOfTimeHandover, {
		title: 'Extensions of Time',
		className: 'eots-handover'
	})
);
